import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { ReactLenis } from 'lenis/react';
import { Toaster } from 'sonner';
import Analytics from './components/Analytics';
import Nav from './components/Nav';
import Footer from './components/Footer';
import Home from './pages/Home';
import MassageServices from './pages/MassageServices';
import Veterans from './pages/Veterans';
import VirtualDoula from './pages/VirtualDoula';
import PracticeHub from './pages/PracticeHub';
import About from './pages/About';
import Contact from './pages/Contact';
import FAQ from './pages/FAQ';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Policies from './pages/Policies';
import PrivacyPolicy from './pages/PrivacyPolicy';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error) {
    console.error('App error:', error);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-brand-cream px-6 text-center">
          <div>
            <p className="font-display text-4xl text-brand-teal">Something went sideways.</p>
            <p className="mt-3 text-brand-moss">Please refresh the page to continue.</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, [pathname]);
  return null;
}

export default function App() {
  return (
    <ErrorBoundary>
      <Analytics />
      <ReactLenis root options={{ lerp: 0.09, duration: 1.15, smoothWheel: true }}>
        <BrowserRouter>
          <ScrollToTop />
          <div className="grain-overlay" aria-hidden="true" />
          <Nav />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/massage-services" element={<MassageServices />} />
              <Route path="/veterans" element={<Veterans />} />
              <Route path="/virtual-doula" element={<VirtualDoula />} />
              <Route path="/practice-hub" element={<PracticeHub />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/policies" element={<Policies />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </main>
          <Footer />
        </BrowserRouter>
        <Toaster position="bottom-right" toastOptions={{ style: { borderRadius: '12px' } }} />
      </ReactLenis>
    </ErrorBoundary>
  );
}
